/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure } from '@chakra-ui/react';
import { Code } from '../Code';
import React, { useCallback, useEffect, useState } from 'react';
import { JsiFrame, type JsiInterceptorRequest } from '../../interface/Crash';
import { JsiInterceptorFrameRequestsView } from './JsiInterceptorFrameRequestsView';
import { JsiFrameRequestHeaderView } from './RequestHeaderView';
import { JsiFrameResponseHeaderView } from './ResponseHeaderView';
import { DetailsDrawer } from '../detailsDrawer/DetailsDrawer';
import { JsiInterceptorFrameRequestDetailsView } from './JsiInterceptorFrameRequestDetailsView';

export const JsiInterceptorFrameDetailsView: React.FC<{
    frame: JsiFrame;
}> = ({ frame }) => {
    const [selected, setSelected] = useState<JsiInterceptorRequest | undefined>();
    const { isOpen, onOpen, onClose } = useDisclosure();

    // Capture-phase Escape handler: closes only this nested drawer
    // without bubbling to the parent drawer's own close-on-Esc logic.
    useEffect(() => {
        if (!isOpen) return;
        const handler = (e: KeyboardEvent): void => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };
        document.addEventListener('keydown', handler, true);
        return () => document.removeEventListener('keydown', handler, true);
    }, [isOpen, onClose]);

    const handleSelect = useCallback((request: JsiInterceptorRequest): void => {
        setSelected(request);
        onOpen();
    }, [onOpen]);

    if (!frame) return null;
    return (
        <>
            <Tabs defaultIndex={0} pt={25}>
                <TabList>
                    {frame.requests && <Tab>Requests</Tab>}
                    {frame.initial_dom && <Tab>Initial DOM</Tab>}
                    <Tab>Request Header</Tab>
                    <Tab>Response Header</Tab>
                </TabList>

                <TabPanels>
                    {frame.requests && (
                        <TabPanel>
                            <JsiInterceptorFrameRequestsView requests={frame.requests} setSelected={handleSelect} />
                        </TabPanel>
                    )}
                    {frame.initial_dom && (
                        <TabPanel>
                            <Code mt={5} p={3} wrapWhiteSpace={true} textToCopy={frame.initial_dom}>
                                {frame.initial_dom}
                            </Code>
                        </TabPanel>
                    )}
                    <TabPanel>
                        <JsiFrameRequestHeaderView frame={frame} />
                    </TabPanel>
                    <TabPanel>
                        <JsiFrameResponseHeaderView frame={frame} />
                    </TabPanel>
                </TabPanels>
            </Tabs>
            <DetailsDrawer
                isOpen={isOpen}
                size="xl"
                onClose={onClose}
                title=""
                useInert={false}
                closeOnEsc={false}
            >
                {selected && <JsiInterceptorFrameRequestDetailsView request={selected} />}
            </DetailsDrawer>
        </>
    );
};
